import { SUBSCRIPTION_PLAN } from '@gymaholic/packages'

export function isPremiumSubscriptionUserUtil (subscriptionPlan) {
  return [
    SUBSCRIPTION_PLAN.PREMIUM,
    SUBSCRIPTION_PLAN.EARLY_BIRD_PREMIUM,
    SUBSCRIPTION_PLAN.PREMIUM_YEARLY,
    SUBSCRIPTION_PLAN.PREMIUM_YEARLY_2025,
    SUBSCRIPTION_PLAN.PREMIUM_2025
  ].includes(subscriptionPlan)
}
